module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-5 pb-5"
  }, [_c('div', {
    staticClass: "width550 mx-auto mb-5",
    on: {
      "click": _vm.setCompletedTasks
    }
  }, [_c('div', {
    staticClass: "fs-large font-weight-600 darker pl-2"
  }, [_vm._v("Set your business configurations.")]), _vm._v(" "), _c('div', {
    staticClass: "bg-medium w-100 mt-2"
  }, [_c('div', {
    staticClass: "progressBar bg-color-3",
    style: ({
      'width': _vm.completePercent + '%'
    })
  })])]), _vm._v(" "), _vm._l((_vm.tasks), function(task) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: task.link
        }
      }
    }, [_c('div', {
      staticClass: "width550 mx-auto panel px-2 border-medium d-flex minHeight127 darker"
    }, [_c('div', {
      staticClass: "col-md-2 text-center p-0"
    }, [_c('img', {
      staticClass: "mt-2",
      attrs: {
        "src": 'static/images/dashboard/startingTasks/' + task.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7 fc-dark"
    }, [_c('div', {
      staticClass: "font-weight-600 fs-large mb-1"
    }, [_vm._v(_vm._s(task.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(task.text))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 text-center p-0 d-flex flex-colum align-items-center"
    }, [(task.done) ? _c('div', {
      staticClass: "color-3 w-100"
    }, [_c('i', {
      staticClass: "ico-check color-3 fs-small mx-auto"
    }), _vm._v(" "), _c('span', {
      staticClass: "fs-small font-weight-600"
    }, [_vm._v("Completed")])]) : _c('div', {
      staticClass: "w-100"
    }, [_c('button', {
      staticClass: "btn bg-color-1 px-4"
    }, [_vm._v("Start")])])])])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center dark font-weight-600 mt-3 pointer underline",
    on: {
      "click": _vm.skipTasksForNow
    }
  }, [_c('u', [_vm._v("Skip this for now")])])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-62c7f722", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62c7f722"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/StratingTasks.vue
// module id = 2458
// module chunks = 0